module.exports = __webpack_public_path__ + "media/images/category/dummy/tops04-747fddc368ceed7c6e72869598f6754c.jpg";